import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard-primeiros-passos',
  templateUrl: './dashboard-primeiros-passos.component.html',
  styleUrls: ['./dashboard-primeiros-passos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardPrimeirosPassosComponent implements OnInit, OnDestroy {

  @Input() temProduto = false;
  @Input() temCliente = false;
  @Input() temVenda = false;

  texts = {
    primeiros_passos: '',
    cadastre_produto: '',
    cadastre_cliente: '',
    realize_venda: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private loadTranslations(): void {
    this.texts = {
      primeiros_passos: this.translate.instant('dashboard.texts.primeiros_passos'),
      cadastre_produto: this.translate.instant('dashboard.texts.cadastre_item'),
      cadastre_cliente: this.translate.instant('dashboard.texts.cadastre_cliente'),
      realize_venda: this.translate.instant('dashboard.texts.realize_venda')
    };
  }

  get progresso(): number {
    let concluidas = 0;
    if (this.temProduto) concluidas++;
    if (this.temCliente) concluidas++;
    if (this.temVenda) concluidas++;
    return Math.round((concluidas / 3) * 100);
  }

  irParaProduto(): void {
    this.router.navigate(['/produtos']);
  }

  irParaCliente(): void {
    this.router.navigate(['/clientes']);
  }

  irParaVenda(): void {
    this.router.navigate(['/vendas']);
  }
}
